export default "__VITE_ASSET__tcc3ErGj__"